import React, { useContext, useEffect } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import "./Login.scss";
import axios from "axios";
import MyContext from "../Context/MyContext";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const Navigate = useNavigate();

  const loginMessage = (login) => {
    return `Thanks You have logged in at ${login}`;
  };

  useEffect(() => {
    sessionStorage.getItem("token") && Navigate("/");
  }, []);

  const {
    setLogintime,
    setLoader,
    setOpen,
    setMessage,
    setToken,
    setName,
    url,
    setDomain,
  } = useContext(MyContext);

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .email("Invalid email format")
      .required("Email is required"),
    password: Yup.string()
      .min(6, "Password must be at least 6 characters")
      .required("Password is required"),
  });

  // Initial values
  const initialValues = {
    email: "",
    password: "",
  };

  // Form submission handler
  const handleSubmit = async (values, { resetForm }) => {
    setLoader(true);

    document.querySelector("body").style.overflow = "hidden";
    try {
      const { data } = await axios.post(`${url}/login`, values);

      if (data.success) {
        sessionStorage.setItem("login", data.loginTime);
        setLogintime(data.loginTime);
        setMessage(loginMessage(data.loginTime));
        setOpen(true);

        setToken(data.data);
        sessionStorage.setItem("token", data.data);

        setDomain(data.domain);
        sessionStorage.setItem("domain", data.domain);

        sessionStorage.setItem("email", values.email); // ✅ Add this line

        Navigate("/");
        resetForm();
      } else {
        setMessage(data.error);
        setOpen(true);
      }
    } catch (error) {
      console.error("Error during registration", error);
      alert("login failed. Please try again.");
    } finally {
      setLoader(false);

      document.querySelector("body").style.overflow = "auto";
    }
  };

  return (
    <div className="login-container">
      <h1 className="head">Vemox</h1>
      <h1 className="headl">Welcome Back</h1>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {() => (
          <Form className="form">
            <div className="form-group">
              <label htmlFor="email" className="form-label">
                Email:
              </label>
              <Field
                type="email"
                id="email"
                name="email"
                className="form-input"
                placeholder="Enter your email"
              />
              <ErrorMessage
                name="email"
                component="div"
                className="form-error"
              />
            </div>

            <div className="form-group">
              <label htmlFor="password" className="form-label">
                Password:
              </label>
              <Field
                type="password"
                id="password"
                name="password"
                className="form-input"
                placeholder="Enter your password"
              />
              <ErrorMessage
                name="password"
                component="div"
                className="form-error"
              />
            </div>

            <button type="submit" className="btn btn-primary">
              Login
            </button>
          </Form>
        )}
      </Formik>

      <button onClick={() => Navigate("/register")} className="btn2">
        Register
      </button>
    </div>
  );
};

export default Login;
